<template>
    <div v-loading="loading" element-loading-text="Đang tải dữ liệu..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)" v-if="isShow"
        class="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50 text-[14px]"
        @click.self="closePopup()">
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border border-white/20 md:w-[420px] w-[95%] h-min overflow-hidden"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <!-- Popup content -->
            <h2 class="relative w-full bg-white/80 backdrop-blur-md border-b border-gray-100 p-4 text-center text-gray-800 font-bold text-[16px] tracking-wide z-50">Xuất File Excel
                <div class="absolute right-4 top-3 text-[20px] text-gray-400 hover:text-gray-700 transition-colors flex items-center justify-center p-1">
                    <font-awesome-icon :icon="['fas', 'xmark']" class="cursor-pointer" @click="closePopup()" />
                </div>
            </h2>
            <div class="p-6">
                <div v-if="this.$app.multipleSelection.length === 0" class="mb-5">
                    <div class="mb-3">
                        <div class="text-sm font-semibold text-gray-700 mb-2">Thời gian xuất:</div>
                        <el-date-picker v-model="dateValue" class="custom-picker w-full custom-date-picker" type="daterange"
                            format="dd/MM/yyyy" range-separator="-" start-placeholder="Ngày bắt đầu"
                            end-placeholder="Ngày kết thúc" popper-class="custom-date-popper-high-z" @change="handleDateChange">
                        </el-date-picker>
                    </div>
                    <div class="grid grid-cols-3 gap-2 items-center bg-gray-50 p-2 rounded-xl border border-gray-100">
                        <div class="text-sm flex items-center justify-center" v-for="(label, key) in dateOptions"
                            :key="key">
                            <label class="flex items-center cursor-pointer group">
                                <input type="radio" :id="'filter' + key" v-model="selectedRange" :value="key"
                                    @change="pickDate()" class="w-4 h-4 text-brand bg-white border-gray-300 focus:ring-brand transition-colors" />
                                <span class="ml-1.5 font-medium text-gray-600 group-hover:text-brand transition-colors text-[13px]">{{ label }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="mb-5">
                    <div class="text-sm font-semibold text-gray-700 mb-2">Chọn mẫu xuất <span class="text-red-500">*</span></div>
                    <div class="relative">
                        <select id="billType"
                            class="h-11 border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-sm text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none"
                            v-model="billExportType">
                            <option v-for="type in listBillExportType" :key="type.value" :value="type.value">
                                {{ type.text }}
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                        </div>
                    </div>
                </div>
                <div class="mb-6 relative">
                    <div class="text-sm font-semibold text-gray-700 mb-2">Cửa hàng:</div>
                    <div class="relative w-full">
                        <el-autocomplete class="w-full custom-autocomplete" v-model="fillBillAddress"
                            placeholder="Tìm cửa hàng" :fetch-suggestions="searchStore"
                            :props="{ label: 'label', value: 'value' }" clearable @clear="handleClear"
                            @select="handleSelect">
                            <template slot-scope="{ item }">
                                <div class="text-[13px] py-1 text-gray-700 font-medium">
                                    {{ item.label }}
                                </div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>

                <div class="mt-4 text-center">
                    <button @click="exportExcel"
                        class="w-full h-12 bg-brand text-white text-[15px] font-bold rounded-xl shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex items-center justify-center gap-2">
                        <font-awesome-icon :icon="['fas', 'file-excel']" /> Tải File Excel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const API_URL = process.env.VUE_APP_API_URL;
import dayjs from "dayjs";
export default {
    components: {

    },
    computed: {
        currentRange() {
            return this.dateRanges[this.selectedRange];
        },

    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: []
        },
        tabNumber: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            dateValue: null,
            fillterTime: {
                startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
                endDate: dayjs().endOf("month").format("YYYY-MM-DD")
            },
            selectedRange: "thisMonth",
            dateOptions: {
                thisWeek: "Tuần này",
                thisMonth: "Tháng này",
                lastMonth: "Tháng trước",
            },
            dateRanges: {
                thisWeek: {
                    start: dayjs().startOf("week").format("YYYY-MM-DD"),
                    end: dayjs().endOf("week").format("YYYY-MM-DD"),
                },
                thisMonth: {
                    start: dayjs().startOf("month").format("YYYY-MM-DD"),
                    end: dayjs().endOf("month").format("YYYY-MM-DD"),
                },
                lastMonth: {
                    start: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                    end: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                },
            },
            isVisible: true,
            departmentAdmin: null,
            listBillExportType: [
                { value: 1, text: 'Phiếu thanh toán tạm ứng' },
                { value: 2, text: 'Phiếu mua hàng nhập kho' }
            ],
            billExportType: 1,
            fillBillAddress: null,
            fillBillAddressValue: null,
            searchTimeout: null,
            listAddress: [],
            listAddressDefault: []
        }
    },
    mounted() {
        this.fetchStores()
        this.dateValue = [dayjs().startOf("month").format("YYYY-MM-DD"), dayjs().endOf("month").format("YYYY-MM-DD")]
    },
    methods: {
        async fetchStores() {
            try {
                const response = await this.$axios.get(`${API_URL}/stores/getall`); // Đổi URL nếu cần
                this.listAddressDefault = response.data
            } catch (error) {
                console.error("Lỗi khi lấy danh sách cửa hàng:", error);
            }
        },
        searchStore(queryString, cb) {
      if (!queryString) {
        return cb(
          this.listAddressDefault.map((item) => ({
            label: item.shortaddress,
            value: item.fulladdress,
          }))
        );
      }

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const searchLower = queryString.toLowerCase();

        const filtered = this.listAddressDefault.filter((item) => {
          const short = item.shortaddress ? item.shortaddress.toLowerCase() : "";
          const full = item.fulladdress ? item.fulladdress.toLowerCase() : "";
          return short.includes(searchLower) || full.includes(searchLower);
        });

        this.listAddress = filtered.map((item) => ({
          label: item.shortaddress || "Không có địa chỉ ngắn",
          value: item.fulladdress || "",
        }));

        cb(this.listAddress);
      }, 300);
    },


    // ✅ Khi chọn item
    handleSelect(item) {
      this.fillBillAddress = item.label; // hiển thị label trong input
      this.fillBillAddressValue = item.code; // lưu toàn bộ thông tin nếu cần
    },

    // ✅ Khi bấm nút xoá
    handleClear() {
      this.fillBillAddress = "";
      this.fillBillAddressValue = null;
      console.log("Đã xoá địa chỉ");
    },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        handleDateChange(value) {
            if (!value || value.length !== 2) {
                this.dateValue = null;
                return;
            }
            this.dateValue = value.map(date => this.formatDate(date));

            this.selectedRange = null;
            this.fillterTime = {
                startDate: dayjs(this.dateValue[0]).startOf("month").format("YYYY-MM-DD"),
                endDate: dayjs(this.dateValue[1]).endOf("month").format("YYYY-MM-DD")
            }
        },
        pickDate() {
            const { start, end } = this.currentRange;
            this.dateValue = [start, end]
            this.fillterTime = {
                startDate: start,
                endDate: end
            }
        },
        async exportExcel() {
            const data = {
                selectedIds: this.$app.multipleSelection.map(bill => bill.id),
                timeRange: {
                    startDate: this.dateValue[0],
                    endDate: this.dateValue[1]
                },
                billExportType: this.billExportType,
                paymentStatus: this.tabNumber,
                storeAddress: this.fillBillAddressValue || null
            }
            await this.$axios.post(
                `${API_URL}/bills/export`,
                data,
                {
                    responseType: 'blob', // ✅ Đặt ở đây, KHÔNG nằm trong headers
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Authorization': `Bearer ${this.$app.token}`, // ✅ nên dùng "Authorization" chuẩn hơn
                    },
                }
            ).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url
                let billType = this.listBillExportType.find(el => el.value == this.billExportType)
                link.setAttribute('download', `${billType.text}.xlsx`);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                if (err.status === 404) {
                    this.$notify.error({
                        title: 'Lỗi xuất Excel',
                        message: 'Không tìm thấy hóa đơn phù hợp để xuất file Excel.'
                    });
                    return;
                } else {
                    this.$notify.error({
                        title: 'Lỗi xuất Excel',
                        message: err.message || 'Đã có lỗi xảy ra khi xuất file Excel.'
                    });
                }
            });
        },
        formatDate(date) {
            if (!date) return null;
            const offset = date.getTimezoneOffset() * 60000; // Lấy offset của múi giờ
            return new Date(date - offset).toISOString().split("T")[0]; // Trả về YYYY-MM-DD
        },
    }
}
</script>
<style scoped>
.winput {
    width: 100% !important;
}

.custom-date-picker ::v-deep(.el-range-input) {
    background-color: transparent;
}

.custom-date-picker ::v-deep(.el-input__inner) {
    height: 44px;
    border-radius: 0.75rem;
    border: 1px solid #e5e7eb;
    background-color: #f9fafb;
    font-weight: 500;
    color: #1f2937;
    transition: all 0.2s ease;
}

.custom-date-picker ::v-deep(.el-input__inner:focus) {
    border-color: var(--color-brand);
    box-shadow: 0 0 0 2px rgba(2, 75, 179, 0.2);
    background-color: #ffffff;
}

.custom-autocomplete ::v-deep(.el-input__inner) {
    height: 44px;
    line-height: 44px;
    border-radius: 0.75rem;
    border: 1px solid #e5e7eb;
    background-color: #f9fafb;
    font-weight: 500;
    color: #1f2937;
    transition: all 0.2s ease;
}

.custom-autocomplete ::v-deep(.el-input__inner:focus) {
    border-color: var(--color-brand);
    box-shadow: 0 0 0 2px rgba(2, 75, 179, 0.2);
    background-color: #ffffff;
}

@media (max-width: 450px) {

    .el-date-editor.el-range-editor.el-input__inner.custom-picker.el-date-editor--daterange {
        width: 100%;
    }

    .el-picker-panel.el-date-range-picker.el-popper.custom-prop {
        top: 196px !important;
        width: 90%;
        box-sizing: border-box;

        .el-picker-panel__body-wrapper {
            width: 100%;
            box-sizing: border-box;

            .el-picker-panel__body {
                width: 100%;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                min-width: auto;

                .el-date-range-picker__content {
                    width: 100%;
                    box-sizing: border-box;
                }
            }
        }
    }
}

@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>